import { render, staticRenderFns } from "./transportForm.vue?vue&type=template&id=b6ef31c8&scoped=true&"
import script from "./transportForm.vue?vue&type=script&lang=js&"
export * from "./transportForm.vue?vue&type=script&lang=js&"
import style0 from "./transportForm.vue?vue&type=style&index=0&lang=css&"
import style1 from "./transportForm.vue?vue&type=style&index=1&id=b6ef31c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6ef31c8",
  null
  
)

export default component.exports